<!-- 文本切换展示与编辑操作组件 -->
<template>
  <div class="cms-common-text-edit">
    <template v-if="mode">
      <span
        class="cms-common-edit-input"
        :class="{ 'input-hight': highlight }"
        contenteditable
        :data-content="text"
        @focus.prevent.stop="highlight = true"
        @blur.prevent.stop="handleEditEmit"
      >{{ text }}</span>
    </template>
    <template v-else>{{ text }}</template>
  </div>
</template>
<script>
export default {
  props: {
    mode: [Boolean, String],
    text: String,
    changeKey: String,
    sendData: [Array, Object]
  },
  data () {
    return {
      highlight: false
    }
  },
  methods: {
    handleEditEmit (event) {
      this.highlight = false
      const relValue = event.target.innerText
      this.$emit('update:text', relValue)
      this.$emit('AddFastSiteEdit', {
        key: this.changeKey,
        data: this.sendData
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.cms-common-text-edit
  display inline-block
  .cms-common-edit-input
    &:focus-visible
      outline 0
  .input-hight
    background #3370ff
    color white
    transition background 0.3s ease
    padding 0 6px
    border-radius 2px
</style>